export default __webpack_public_path__ + "static/media/Linero1Close.0ff21768.jpg";